export default __webpack_public_path__ + "static/media/2.fd790e4b.jpg";